import {Component, OnInit} from "@angular/core";
import {LoggerService} from "../../../common/logger.service";
import {RestResponse} from "../../../common/rest-response.model";
import {PersonalAuthResponse} from "../personal-auth.model";
import {ActivatedRoute} from "@angular/router";
import {BaseComponent} from "../../../base.component";
import {UserService} from "../../../common/user.service";
import {PersonalAuthService} from "../personal-auth.service";
import {TranslateComponent} from "../../../translation/translate.component";

@Component({
    selector: 'kr-enroll-auth',
    templateUrl: './kr-enroll-auth.component.html',
    standalone: true,
    imports: [
        TranslateComponent
    ]
})
export class KrEnrollAuthComponent extends BaseComponent implements OnInit {

    loading: boolean;
    title: string = 'cart.usanaq.auth.complete.error.title';
    body: string = 'cart.usanaq.auth.complete.error.body';

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private personalAuthService: PersonalAuthService,
        private route: ActivatedRoute,
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.loading = true;
        const encodeData = this.route.snapshot.queryParamMap.get("EncodeData");
        if (encodeData) {
             /*
             encodeData is automatically decoded via $location.search().  dont need to call decodeURIComponent().
             NiceID third party backend client is expecting %20 to be decoded as plus(+).
             however, the decoding done above is replacing the original raw URL query param %20 with a space. it is breaking the NiceID third party backend client.
             here we have to manually replace those spaces with the desired plus(+)
             AND use as POST request body instead of a GET request param (due to Spring automatically replacing a plus(+) in a request param with a space)
             */
            this.personalAuthService.decodeAuthResponse(encodeData.replace(/ /gi,"+")).subscribe((response: RestResponse) => {
                this.loading = false;
                if (response.success && !!response.message) {
                    this.personalAuthService.storePersonalAuthResponse(response.message);
                    this.title = 'cart.usanaq.auth.complete.success.title';
                    this.body = 'cart.usanaq.auth.complete.success.body';
                } else {
                    this.personalAuthService.storePersonalAuthResponse(new PersonalAuthResponse());
                }
            }, (rejectResponse: RestResponse) => {
                this.log.error(rejectResponse);
                this.loading = false;
                this.personalAuthService.storePersonalAuthResponse(new PersonalAuthResponse());
            });
        } else {
            this.loading = false;
        }
    }

    close() {
        window.close();
    }

}
